import React, {Component} from 'react';
import {Button, Form, FormGroup, Icon} from 'semantic-ui-react';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {profilePhoneNumberOptions} from 'app-ui-componentlibrary/dist/common/constants';

export class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    if (props.index === 0) {
      this.state = {
        phoneTypeLabel: 'Phone type',
        phoneNumberLabel: 'Phone number',
        extensionLabel: 'Extension',
      };
    }
  }

  handleChange = (e, res) => {
    const number = {...this.props.number, [res.name]: res.value};
    this.props.handleChange(e, {
      name: this.props.index,
      value: number,
    });
  };

  handlePhoneTypeChange = (e) => {
    this.handleChange(e, {name: 'phoneType', value: e.target.value});
  };

  handleNumberChange = (e, res) => {
    let fullNumber = res.value.replace(/-/g, '');
    let areaCode = fullNumber.substring(0, 3);
    let phoneNumber = fullNumber.substring(3);

    const number = {
      ...this.props.number,
      areaCode: areaCode,
      phoneNumber: phoneNumber,
    };
    this.props.handleChange(e, {name: this.props.index, value: number});
  };
  removeNumber = (e) => {
    this.props.handleChange(e, {name: this.props.index, value: null});
  };

  static formatPhoneNumber(areaCode, phoneNumber) {
    let value = '';
    if (areaCode) {
      value += areaCode;
    }
    if (phoneNumber) {
      value += '-' + phoneNumber.substring(0, 3);
      if (phoneNumber.length > 3) {
        value += '-' + phoneNumber.substring(3);
      }
    }
    return value;
  }

  render() {
    let currentPhoneNumber = PhoneNumber.formatPhoneNumber(
      this.props.number.areaCode,
      this.props.number.phoneNumber
    );

    let {index} = this.props;

    return (
      <FormGroup>
        <label for={'phoneType' + index} className="sr-only">
          Phone type
        </label>
        <InlineSelect
          name="phoneType"
          id={'phoneType' + index}
          label={this.state.phoneTypeLabel}
          options={profilePhoneNumberOptions}
          displayError={this.props.number.phoneTypeError}
          errorMessages={this.props.number.phoneTypeError}
          value={this.props.number.phoneType}
          handleChange={this.handlePhoneTypeChange}
        />
        <label for={'phoneNumber' + index} className="sr-only">
          Phone number
        </label>
        <InlineTextBoxField
          title="Phone number required"
          name="phoneNumber"
          id={'phoneNumber' + index}
          label={this.state.phoneNumberLabel}
          placeholder="xxx-xxx-xxxx"
          value={currentPhoneNumber}
          displayError={this.props.number.phoneError}
          errorMessages={this.props.number.phoneError}
          handleChange={this.handleNumberChange}
          maxLength={12}
        />
        <label for={'phoneExtension' + index} className="sr-only">
          Extension
        </label>
        <InlineTextBoxField
          width={3}
          title="Extension"
          name="phoneExtension"
          id={'phoneExtension' + index}
          label={this.state.extensionLabel}
          value={this.props.number.phoneExtension}
          displayError={this.props.number.phoneExtensionError}
          errorMessages={this.props.number.phoneExtensionError}
          placeholder="xxxx"
          handleChange={this.handleChange}
          maxLength={4}
        />
        {this.props.index !== 0 && (
          <Button
            secondary
            basic
            icon
            title="Remove number"
            name="removeNumber"
            id={'removeNumber' + index}
            onClick={this.removeNumber}
            width={2}
          >
            <Icon name="trash alternate outline" />
          </Button>
        )}
      </FormGroup>
    );
  }
}
